import React, { useRef, useEffect } from 'react'
import { Modalize as NativeModalize } from 'react-native-modalize'
import { StyleSheet, View, ViewPropTypes } from 'react-native'
import PropTypes from 'prop-types'

import IconButton from '../IconButton'
import { isMobileDevice } from '../../tools/platform'
import { useTheme } from '../../theming/ThemeProvider'

export default function Modalize ({ open, children, handleModal, alwaysOpen, autoHandleClose, ...props }) {
  const modalRef = useRef(null)
  const { theme } = useTheme()

  useEffect(() => {
    const modal = modalRef.current
    if (modal) {
      if (open) {
        modal.open('top')
      } else if (autoHandleClose) {
        modal.close(alwaysOpen ? 'alwaysOpen' : null)
      }
    }
  }, [open, alwaysOpen, autoHandleClose])

  const handleArrow = () => {
    const modal = modalRef.current
    if (open) {
      modal.close(alwaysOpen ? 'alwaysOpen' : null)
    } else {
      handleModal(true)
    }
  }

  return (
    <NativeModalize
      ref={modalRef}
      onClosed={() => handleModal(false)}
      alwaysOpen={alwaysOpen}
      handlePosition='inside'
      handleStyle={!isMobileDevice() ? styles.hideMobileHandle : null}
      modalStyle={{
        backgroundColor: theme.CARD_BACKGROUND
      }}
      {...props}
    >
      <WebArrow open={open} handleArrow={handleArrow} />
      <View style={styles.container}>
        {children}
      </View>
    </NativeModalize>

  )
}

const WebArrow = ({ open, handleArrow }) => {
  return !isMobileDevice() ? (
    <View style={styles.header}>
      <View style={{ alignSelf: 'center' }}>
        <IconButton
          icon={open ? 'AngleDown' : 'AngleUp'}
          color='WHITE'
          iconColor='GEYSER'
          onPress={handleArrow}
        />
      </View>
    </View>
  ) : null
}

const styles = StyleSheet.create({
  container: {
    margin: 30
  },
  header: {
    position: 'absolute',
    width: '100%',
    justifyContent: 'center',
    paddingTop: 5
  },
  hideMobileHandle: {
    display: 'none'
  }
})

Modalize.propTypes = {
  open: PropTypes.bool,
  autoHandleClose: PropTypes.bool,
  children: PropTypes.any.isRequired,
  adjustToContentHeight: PropTypes.bool,
  handleModal: PropTypes.func,
  alwaysOpen: PropTypes.number,
  overlayStyle: ViewPropTypes.style,
  modalTopOffset: PropTypes.number
}

Modalize.defaultProps = {
  open: false,
  children: '',
  fullView: false,
  adjustToContentHeight: false,
  handleModal: () => {},
  alwaysOpen: null,
  overlayStyle: null,
  modalTopOffset: null
}

WebArrow.propTypes = {
  open: PropTypes.bool,
  handleArrow: PropTypes.func
}

export { WebArrow }
